module.exports = __webpack_public_path__ + "4b66a910e721edd4482dd09ad0fb4dde.woff2";